export default __webpack_public_path__ + "static/media/blend-cookie@2x.28217907.png";